<!-- eslint-disable no-mixed-operators -->
<!-- eslint-disable no-bitwise -->
<template>
  <div
    v-if="appointment.schedule.dayOfMonth[0] === Number(selectedDay)"
    class="thumbnail-appointment"
    :style="`background-color: ${lightenColor(appointment.color)}; border-left: 20px solid ${darkenColor(appointment.color)};`"
  >
    <div class="thumbnail-appointment__jobName">
      {{ jobName }}
    </div>
    <div>
      <v-icon>
        mdi-clock-outline
      </v-icon>

      {{ appointment.schedule.durationUnit === 'days' ? $t('siteDashboard.description.daily') : transformTime(appointment.schedule.times[0]) }}
    </div>
  </div>
</template>

<script>
export default {
    name: 'ThumbnailAppointment',
    props: {
        appointment: {
            type: Object,
            required: true,
        },
        selectedDay: {
            type: String,
            required: true,
        },
        jobName: {
            type: String,
            required: true,
        },
    },
    methods: {
        darkenColor(hex, factor = 0) {
            let r = parseInt(hex.slice(1, 3), 16);
            let g = parseInt(hex.slice(3, 5), 16);
            let b = parseInt(hex.slice(5, 7), 16);

            r = Math.max(0, Math.min(255, r - r * factor));
            g = Math.max(0, Math.min(255, g - g * factor));
            b = Math.max(0, Math.min(255, b - b * factor));

            return `#${[r, g, b].map(c => Math.round(c).toString(16).padStart(2, '0')).join('').toUpperCase()}`;
        },

        lightenColor(hex, factor = 0.7) {
            let r = parseInt(hex.slice(1, 3), 16);
            let g = parseInt(hex.slice(3, 5), 16);
            let b = parseInt(hex.slice(5, 7), 16);

            r = Math.min(255, r + r * factor);
            g = Math.min(255, g + g * factor);
            b = Math.min(255, b + b * factor);

            return `#${[r, g, b].map(c => Math.round(c).toString(16).padStart(2, '0')).join('').toUpperCase()}`;
        },
        transformTime(time) {
            // Si l'heure est de ce type 9:00 on laisse si elle est de ce type 09 , on soit rajouter ":00"
            if (time.length < 4) {
                return `${time}:00`;
            }
            return time;
        },
    },
};
</script>


<style
    scoped
    lang="scss"
>

.thumbnail-appointment {
    background-color: red;
    height: 90px;
    border-radius: 5px;
    width: 80%;
    margin-left: 10%;
    margin-right: 10%;
    margin-top: 10px;
    margin-bottom: 10px;
    padding: 10px;
    color: #26384B;
    &__jobName {
        font-weight: 600;
        font-size: 1.3rem;
    }
}

</style>
